import { useContext, useEffect, useRef, useState } from "react";
import { Colour } from "../Variables";
import { AppContext } from "../../contexts/AppContext";
import { useNavigate } from "react-router";
import { API_GetPrivacyPolicyData, PrivacyPolicyData } from "../../apis/ApisPrivacyPolicyUpdate";
import { Card } from "../components/Shared/Card";
import moment from "moment";

export function PrivacyPolicyUpdate() {

    const inputConfirmedAHRef = useRef<HTMLInputElement>(null);
    const inputConfirmedAHOnDemandRef = useRef<HTMLInputElement>(null);
    const [confirmedAH, setConfirmedAH] = useState<boolean>(false);
    const [confirmedAHOnDemand, setConfirmedAHOnDemand] = useState<boolean>(false);
    const [data, setData] = useState<PrivacyPolicyData>();
    const [error, setError] = useState<boolean>(false);
    const app = useContext(AppContext);
    let navigate = useNavigate();

    const getPrivacyPolicyData = async () => {
        let data = await API_GetPrivacyPolicyData();
        setData(data);
    }

    const confirmPrivacyPolicy = async () => {
        if (confirmedAH && confirmedAHOnDemand) {
            app.verifyPolicyRequired();
            navigate("/");
        }
        else {
            setError(true);
            return;
        }
    }

    useEffect(() => {
        getPrivacyPolicyData();
    }, []);

    return (
        <>
            {data && <Card title="Privacy policy update" headerTheme={Colour.Primary} headerClasses={""} >
                <div className="p-3" >Our privacy policy was updated on {moment(new Date(data.PolicyUpdatedDate)).format("DD/MM/yyyy")}. Please review how your data will be used before continuing.</div>
                <div className="p-3" dangerouslySetInnerHTML={{ __html: app.baseFeatures?.PrivacyPolicyText }}></div>
                <div className="p-3" dangerouslySetInnerHTML={{ __html: app.baseFeatures?.CompanyPrivacyPolicyText }}></div>
                <div className="p-3">I confirm that I have read the privacy policy and agree that my data will be used as described by:</div>
                <div className="p-2">
                    <span>
                        <input ref={inputConfirmedAHRef} id="checkboxAH" type="checkbox" className="form-check-input ms-2 me-1"
                            checked={confirmedAH}
                            onChange={e => {
                                setConfirmedAH(e.currentTarget.checked);
                                if (e.currentTarget.checked) {
                                    inputConfirmedAHRef?.current?.classList.remove("is-invalid");
                                    inputConfirmedAHRef?.current?.classList.add("is-valid");
                                }
                                else {
                                    inputConfirmedAHRef?.current?.classList.add("is-invalid");
                                    inputConfirmedAHRef?.current?.classList.remove("is-valid");
                                }
                            }} />
                        <label className="form-check-label no-highlight-clicker me-1" htmlFor={"checkboxAH"}>
                            AllHires
                        </label>
                    </span>
                </div>
                <div className="p-2">
                    <span>
                        <input ref={inputConfirmedAHOnDemandRef} id="checkboxAHOnDemand" type="checkbox" className="form-check-input ms-2 me-1"
                            checked={confirmedAHOnDemand}
                            onChange={e => {
                                setConfirmedAHOnDemand(e.currentTarget.checked);
                                if (e.currentTarget.checked) {
                                    inputConfirmedAHOnDemandRef?.current?.classList.remove("is-invalid");
                                    inputConfirmedAHOnDemandRef?.current?.classList.add("is-valid");
                                }
                                else {
                                    inputConfirmedAHOnDemandRef?.current?.classList.add("is-invalid");
                                    inputConfirmedAHOnDemandRef?.current?.classList.remove("is-valid");
                                }
                            }} />
                        <label className="form-check-label no-highlight-clicker me-1" htmlFor={"checkboxAHOnDemand"}>
                            {app.firmName}
                        </label>
                    </span>
                </div>
                <div className="p-2">
                    <button className="btn btn-alt mt-3 mb-2" type="submit" onClick={e => { e.preventDefault(); confirmPrivacyPolicy(); }}>Confirm</button>
                </div>
                {error && <div className="alert alert-danger">
                    In order to begin an application we require your consent to process your application. Please review the information about how we use your data and consent if you wish to continue.
                </div>}
            </Card>}
        </>
    );
}
